module.exports = require("util");


/*****************
 ** WEBPACK FOOTER
 ** external "util"
 ** module id = 80
 ** module chunks = 0
 **/